<template>
  <div>
    <h3>Dictionaries</h3>
    <ul>
      <li v-for="item in items" :key="item.id" class="dictionary-listings">
        <ul class="dictionary-list-group">
          <li class="dictionary-name">
            <h4>{{ item.name }}</h4>
          </li>
          <li class="dictionary-id"><span class="label">ID:</span>{{ item.id }}</li>
          <li>
            <b-button variant="success" @click="selectDictionary(item)">Select Dictionary</b-button>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
h3 {
  background-color: #181d21;
  padding: 5px;
  color: #efd01b;
  margin: 5px auto 10px;
  border: solid 1px #f1f1f1;
  font-size: 1.1rem;
}
ul {
  padding: 0;
}
ul li.dictionary-listings {
  list-style: none;
  border: solid 1px #dde5e7;
  border-radius: 0.3em;
  padding: 5px;
  margin: 5px;
}

ul.dictionary-list-group {
  padding: 5px;
  li {
    list-style: none;
    h4 {
      color: #6e818e;
      font-size: 1.2rem;
      margin-bottom: 5px;
    }
    .label {
      font-weight: bold;
    }
  }
}
</style>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    selectDictionary(item) {
      const vm = this;
      vm.$emit('active', { dictionary: item.id });
      vm.$emit('screen', 'dictionaryTable');
    },
  },
};
</script>
